import { ArrowRight } from "zudoku/icons";
import { ProductNavigation } from "./ProductNavigation.js";
import "./portal.css";

export const SiteHeader = () => (
  <header className="ax-header">
    <div className="ax-header-inner">
      <a className="ax-brand" href="/" aria-label="安象产品中心首页">
        <img src="/brand/logo.png" alt="安象科技" />
      </a>
      <ProductNavigation home />
      <a className="ax-header-link" href="/support">
        联系咨询 <ArrowRight size={14} />
      </a>
    </div>
  </header>
);
